import {combineReducers} from 'redux';
import fundTable from './fundTable';
import scrolling from './scrolling';

export const fundCentre =  combineReducers({
    fundTable,
    scrolling
});
